<script setup lang="js">
import { onMounted } from "vue";
import { useAuth } from "@/composables/useAuth.js";
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";

const { initializeAuth } = useAuth();

onMounted(() => {
  initializeAuth();
});
</script>

<template>
  <main>
    <RouterView />
    <Toast position="bottom-right" />
    <ConfirmDialog />
  </main>
</template>
